import { render, staticRenderFns } from "./OrgDash.vue?vue&type=template&id=5caba4a2&"
import script from "./OrgDash.vue?vue&type=script&lang=js&"
export * from "./OrgDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports